import { render, staticRenderFns } from "./Development.vue?vue&type=template&id=4539929d"
import script from "./Development.vue?vue&type=script&lang=js"
export * from "./Development.vue?vue&type=script&lang=js"
import style0 from "./Development.vue?vue&type=style&index=0&id=4539929d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports